module.exports = __webpack_public_path__ + "static/media/HCMM338.d472bd40.jpg";